import { UTILS } from "../../utils";

var DONATE_DATA_MANAGER = {
    /**
     * 根据服务器返回列表数据获取前端所需商品列表数据
     * @param {服务器返回列表数据} list 
     */
    getProductListByList(list) {
        var resultList = [];
        list.forEach(data => {
            console.log('getProductListByList--------', data)
            resultList.push({
                pid: data.pid,
                price: parseInt(data.price / 100),
                payType: data.payType
            });
        });
        return resultList;
    }
}

export {
    DONATE_DATA_MANAGER
}